import {useCallback, useState} from 'react';
import {useDispatch, useSelector, useStore} from 'react-redux';
import {selectGuestsOfHonor, selectType} from '~/CreateFabricInvitation/reducers/details/selectors';
import {
  GuestOfHonor,
  OverlayGuestsOfHonor,
} from '~/CreateFabricInvitation/routes/EventDetails/components/OverlayGuestsOfHonor';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {AddButtonWithTitle} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/AddButtonWithTitle/AddButtonWithTitle';
import {FakeInput} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/FakeInput/FakeInput';
import {Divider} from '~library/atoms/Divider';
import {areAllValuesFalsy} from '~library/utils/utils';

export const GuestsOfHonor = () => {
  const store = useStore();
  const [showOverlay, setShowOverlay] = useState(false);
  const dispatch = useDispatch();
  const type = useSelector(selectType);

  const guestsOfHonor: GuestOfHonor[] = useSelector(selectGuestsOfHonor);
  const guestsOfHonorQuantity = guestsOfHonor.filter((goh) => !areAllValuesFalsy(goh)).length;

  const openOverlay = useCallback(() => {
    setShowOverlay(true);
  }, []);

  const closeOverlay = useCallback(() => {
    setShowOverlay(false);
  }, []);

  const remove = useCallback(
    (i: number) => {
      const updatedGohArray = [...guestsOfHonor];
      updatedGohArray.splice(i, 1);
      dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {guestsOfHonor: {update: true, guests: updatedGohArray}},
      });
    },
    [dispatch, guestsOfHonor]
  );

  const submitUpdatedGuestsOfHonor = useCallback(
    (arrToSubmit: GuestOfHonor[]) => {
      for (const goh of arrToSubmit) {
        goh.email = goh.email.toLowerCase();
      }
      store.dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {guestsOfHonor: {update: true, guests: arrToSubmit}},
      });
    },
    [store]
  );

  if (type === 'funeral_memorial_service') {
    return null;
  }

  return (
    <>
      <OverlayGuestsOfHonor
        isOpen={showOverlay}
        onClose={closeOverlay}
        guestsOfHonor={guestsOfHonor}
        onSubmit={submitUpdatedGuestsOfHonor}
      />
      {guestsOfHonorQuantity === 0 ? (
        <AddButtonWithTitle
          label="Guest of Honor"
          onClick={openOverlay}
          dataQaId="add-guestofhonor"
        />
      ) : (
        <>
          <Divider marginBottom="1rem" />
          {guestsOfHonor.map((goh, index) => (
            <FakeInput
              key={goh.email}
              title={`Guest of Honor ${guestsOfHonorQuantity > 1 ? `${index + 1}` : ''}`}
              value={goh.name}
              onClick={openOverlay}
              onRemove={() => remove(index)}
              dataQaId={`event-guestofhonor-${index}`}
            />
          ))}
        </>
      )}
    </>
  );
};
